import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, numberToWords, rootUrl } from "../helpers";
import { useAuth } from "../context/auth-context";
import axios from "axios";

const PaymentVoucher = React.forwardRef(({ data }, ref) => {
  const allData = useOutletContext();
  const auth = useAuth();
  const [voucherData, setVoucherData] = useState({
    preparedBy: {},
    checkedBy: {},
    authorisedBy: {},
    approvedBy: {},
    receivedBy: {},
    budgetDetails: [],
  });

  const {
    commitmentRefNo,
    cheque,
    paye,
    batchNo = "...............",
    journalNo = "...............",
    bSheetNo = "...............",
    date,
    purchaseOrderNo = "...............",
    invoiceNumber = "...............",
    chequeNumber = "...............",
    description,
    amount,
    bank = "...............",
    accountNo = "...............",
    updatedBy,
  } = data;


  
  const getOtherDetails = async () => {
    try {
      const response = await axios.get(rootUrl(`/getDetails/${data.id}`));
      const { other, actions } = response.data;

      const user = allData.users?.find((a) => a.uid === updatedBy);
      const preparerName = `${user?.firstName || ""} ${user?.lastName || ""}`;

      const createSignerDetails = (actionIndex) => {
        const user = allData.users?.find(
          (a) => a.uid === actions[actionIndex]?.uid
        );
        return {
          name: `${user?.firstName || ""} ${user?.lastName || ""}`,
          signature: "...............",
          date: formatDate(actions[actionIndex]?.date),
        };
      };

      setVoucherData({
        preparedBy: {
          name: preparerName,
          signature: "...............",
          date: formatDate(date),
        },
        checkedBy: createSignerDetails(0),
        authorisedBy: createSignerDetails(1),
        approvedBy: createSignerDetails(2),
        receivedBy: {
          name: other?.receivedByName || "...............",
          address: other?.address || "...............",
          signature: "...............",
          nrc: other?.nrc || "...............",
          date: other?.date || "...............",
          contactNo: other?.contactNo || "...............",
        },
        budgetDetails: allData.budget?.filter(
          (budget) => budget.id === data.coa_id
        ),
      });
    } catch (error) {
      console.error("Error fetching additional details:", error);
    }
  };

  useEffect(() => {
    getOtherDetails();
  }, []);

  console.log(allData)
  

  const renderBudgetDetails = () => {
    return (
      <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm mb-4">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-2 py-1">Organisation</th>
            <th className="border px-2 py-1">Dept</th>
            <th className="border px-2 py-1">Unit</th>
            <th className="border px-2 py-1">Programme</th>
            <th className="border px-2 py-1">Sub Program</th>
            <th className="border px-2 py-1">Commitment</th>
            <th className="border px-2 py-1">Chart of Accounts</th>
            <th className="border px-2 py-1">Amount</th>
          </tr>
        </thead>
        <tbody>
          {voucherData.budgetDetails.map((row, index) => (
            <tr key={index} className="text-center">
              <td className="border px-2 py-1">{auth.user.cid}</td>
              <td className="border px-2 py-1">{allData.dept.find(a=>a.id === row.dept)?.name}</td>
              <td className="border px-2 py-1">{row?.unit}</td>
              <td className="border px-2 py-1">
                {allData.program?.find(
                  (a) => a.programCode === row.program
                )?.name || "..............."}
              </td>
              <td className="border px-2 py-1">
                {allData.subProgram?.find(
                  (a) => a.subProgramCode === row.subprogram
                )?.name || "..............."}
              </td>
              <td className="border px-2 py-1"></td>
              <td className="border px-2 py-1">{row.coa}</td>
              <td className="border px-2 py-1">
                {formatToZMW(row.price * row.frequency * row.qty)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderSignerSection = (title, signer) => (
    <div className="border p-2">
      <p className="font-semibold">{title}</p>
      <p>Name: {signer.name}</p>
      <p>Signature: {signer.signature}</p>
      <p>Date: {signer.date}</p>
    </div>
  );

  return (
    <div
      ref={ref}
      className="border border-gray-500 p-4 w-[900px] mx-auto rounded-lg"
    >
      {/* Header Section */}
      <div className="flex justify-between items-center">
        <img src="arms.png" className="w-36" alt="Logo" />
        <h2 className="text-2xl font-semibold text-center">
          MINISTRY OF LOCAL GOVERNMENT AND RURAL DEVELOPMENT
          <br />
          {allData?.council[0]?.name}
        </h2>
        <img src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>

      <h2 className="text-lg font-semibold text-center">PAYMENT VOUCHER</h2>

      {/* Details Section */}
      <div className="flex justify-between items-start mb-2">
        <div>
          <p>COMMITMENT REF. NO.: {commitmentRefNo}</p>
          <p>PAYMENT VOUCHER NO.: {cheque}</p>
          <p>
            PAYEE:{" "}
            {allData.suppliers?.find((a) => a.id === paye)?.name ||
              "..............."}
          </p>
        </div>
        <div className="text-right">
          <p className="font-semibold">BATCH HEADER DETAILS</p>
          <p>BATCH NO.: {batchNo}</p>
          <p>JOURNAL NO.: {journalNo}</p>
          <p>B/SHEET NO.: {bSheetNo}</p>
        </div>
      </div>

      {/* Additional Details */}
      <div className="border border-gray-300 p-2 mb-4 mt-4">
        <p>Date: {formatDate(date)}</p>
        <p>Purchase Order No: {purchaseOrderNo}</p>
        <p>Invoice Number: {invoiceNumber}</p>
        <p>Cheque/EFTA Number: {chequeNumber}</p>
      </div>

      {/* Payment Description */}
      <div className="mb-4">
        <p className="font-semibold">DESCRIPTION OF PAYMENT</p>
        <p className="h-12 border border-gray-300">{description}</p>
      </div>

      {/* Amount Section */}
      <div className="mb-4">
        <p className="font-semibold">AMOUNT</p>
        <p className="h-8 border border-gray-300">{formatToZMW(amount)} : {numberToWords(amount)} Kwacha</p>
      </div>

      {/* Budget Allocation */}
      <p className="font-semibold mb-2">BANK ACCOUNT NAME: {allData.bank.find(a=>a.id === bank)?.name}</p>
      <p className="font-semibold mb-2">ACCOUNT NO: {allData.bank.find(a=>a.id === bank)?.account_no}</p>
      <p className="font-semibold mt-5">Budget Allocation Details</p>
      {renderBudgetDetails()}

      {/* Signatures */}
      <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
        {renderSignerSection("PREPARED BY", voucherData.preparedBy)}
        {renderSignerSection("CHECKED BY", voucherData.checkedBy)}
        {renderSignerSection("AUTHORISED BY", voucherData.authorisedBy)}
        {renderSignerSection("APPROVED BY", voucherData.approvedBy)}
      </div>

      {/* Received By */}
      <div className="border p-2 text-sm">
      <p className="font-semibold">RECEIVED BY</p>
        <div className="grid grid-cols-2 gap-4">

        <div>
        <p>Name: {voucherData.receivedBy.name}</p>
        <p>Address: {voucherData.receivedBy.address}</p>
        <p>Signature: {voucherData.receivedBy.signature}</p>
        </div>

        <div> 
        <p>NRC No.: {voucherData.receivedBy.nrc}</p>
        <p>Date.: {voucherData.receivedBy.date}</p>
        <p>Contact No.: {voucherData.receivedBy.contactNo}</p>
        </div>
        
       
      </div>
      </div>

      <p className="text-xs mt-4">NOTE: EFTA = ELECTRONIC FUNDS TRANSFER ADVICE</p>
    </div>
  );
});

export default PaymentVoucher;
